module.exports = __webpack_public_path__ + "assets/googleIcon-fcd375.svg";